import { useEffect, useState } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <button
      type="button"
      onClick={scrollTop}
      aria-label="返回顶部"
      className={`fixed bottom-6 right-5 md:bottom-8 md:right-8 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-primary-900 shadow-md transition-all duration-300 hover:bg-accent-400 ${
        visible ? 'opacity-100 translate-y-0' : 'pointer-events-none opacity-0 translate-y-3'
      }`}
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}